"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_TAXJAR_CUSTOMER_ENDPOINT = exports.CREATE_TAXJAR_CUSTOMER_ENDPOINT = exports.DISABLE_BUYNOW_ENDPOINT = exports.DELETE_PRODUCT_ENDPOINT = exports.UPDATE_PRODUCT_PRICE_ENDPOINT = exports.EDIT_PRODUCT_ENDPOINT = exports.CREATE_PRODUCT_ENDPOINT = exports.ADMIN_DENY_ACCESS_ENDPOINT = exports.ADMIN_GRANT_ACCESS_ENDPOINT = exports.DELETE_ADMIN_ENDPOINT = exports.EDIT_ADMIN_ENDPOINT = exports.CREATE_ADMIN_ENDPOINT = exports.SEND_VERIFICATION_LINK_ENDPOINT = exports.VERIFY_EMAIL_ENDPOINT = exports.FINANCE_CONTACT_ACTION_ENDPOINT = exports.CREATE_FINANCE_DOCUMENT_ENDPOINT = exports.FETCH_CONTACT_AUTH_ENDPOINT = exports.DELETE_CONTACT_ENDPOINT = exports.EDIT_CONTACT_ENDPOINT = exports.CREATE_CONTACT_ENDPOINT = exports.DELETE_ACCOUNT_ENDPOINT = exports.EDIT_ACCOUNT_ENDPOINT = exports.CREATE_ACCOUNT_ENDPOINT = exports.INVOICE_ADD_COMMENT_ENDPOINT = exports.INVOICE_RE_OPEN_ENDPOINT = exports.INVOICE_REMOVE_ITEM_ENDPOINT = exports.INVOICE_MARK_BUYER_WIRE_AS_PAID_ENDPOINT = exports.INVOICE_MARK_RECEIVED_ENDPOINT = exports.INVOICE_MARK_CLOSED_ENDPOINT = exports.INVOICE_LINE_ITEMS_ENDPOINT = exports.INVOICE_MARK_PAID_ENDPOINT = exports.INVOICE_SELLER_WIRE_ADD_ENDPOINT = exports.INVOICE_ADMIN_BUYER_WIRE_ADD_ENDPOINT = exports.INVOICE_BUYER_WIRE_ADD_ENDPOINT = exports.INVOICE_REGENERATION_ENDPOINT = exports.INVOICE_GENERATION_ENDPOINT = exports.HANDLE_CAPTURE_PAYMENT_ENDPOINT = exports.CANCEL_PAYMENT_INTENT_ENDPOINT = exports.CAPTURE_PAYMENT_INTENT_ENDPOINT = exports.UPDATE_PAYMENT_INTENT_ENDPOINT = exports.CREATE_PAYMENT_INTENT_ENDPOINT = exports.LIST_PAY_METHOD_ENDPOINT = exports.DETACH_PAY_METHOD_ENDPOINT = exports.ATTACH_PAY_METHOD_ENDPOINT = exports.CREATE_CUSTOMER_PAYMENT_ENDPOINT = exports.BANK_ACCOUNT_INFO_INITIAL_STATE = exports.MONTH_NAMES = exports.CONTACT_OBJECT = exports.ROLEMANAGEMENT_OBJECT = exports.PRODUCT_STATUS_FIELDS = void 0;
exports.INVOICE_BUYER_WIRE_PASSED = exports.INVOICE_GENERATION_PASSED = exports.PAYMENT_WEBHOOK_PASSED = exports.PAYMENT_INTENT_CANCEL = exports.PAYMENT_INTENT_CAPTURE = exports.PAYMENT_INTENT_UPDATION_PASSED = exports.PAYMENT_INTENT_INSERTION_PASSED = exports.PAYMENT_METHOD_LIST = exports.PAYMENT_METHOD_DETACH = exports.PAYMENT_METHOD_ATTACH = exports.SERVER_ERROR = exports.FORBIDDEN_ERROR = exports.VALIDATION_ERROR = exports.DATA_NOT_FOUND = exports.DATA_UPDATION_PASSED = exports.DATA_DELETION_PASSED = exports.DATA_INSERTION_PASSED = exports.BAD_REQUEST = exports.ACCESS_DENIED = exports.ACCESS_GRANTED = exports.CREATE_FINANCE_APPLICATION = exports.ZOHO_TO_FIREBASE_WEBSITE_ACCOUNT_SYNC_ENDPOINT = exports.ZOHO_TO_FIREBASE_ACCOUNT_SYNC_ENDPOINT = exports.FIREBASE_TO_ZOHO_ACCOUNT_SYNC_ENDPOINT = exports.ZOHO_TO_FIREBASE_PRODUCT_SYNC_ENDPOINT = exports.FIREBASE_TO_ZOHO_PRODUCT_SYNC_ENDPOINT = exports.CHECK_PRIMARY_CONTACT = exports.MOBILE_VALIDATION = exports.ZOHO_MANUAL_SIGN_LA_AGREEMENT = exports.ZOHO_MANUAL_SIGN_GENERAL_MSA_AGREEMENT = exports.ZOHO_SIGN_GENERAL_RECALL_AGREEMENT = exports.ZOHO_SIGN_GENERAL_MSA_AGREEMENT = exports.ZOHO_SIGN_LISTING_AGREEMENT = exports.ONBOARDING_UPDATE = exports.ONBOARDING_CREATE = exports.REMINDER_NOTIFICATIONS = exports.CLIENT_SIDE_NOTIFICATIONS = exports.ACH_TRANSFER_ENDPOINT = exports.CREATE_DEAL_ENDPOINT = exports.OG_PREVIEW_HELPER_ENDPOINT = exports.PREVEIW_LINK_HELPER_ENDPOINT = exports.UPDATE_EXEMPTION_TYPE_AND_REGIONS_ENDPOINT = exports.REMOVE_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = exports.UPDATE_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = exports.UPLOAD_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = exports.VALIDATE_CUSTOMER_ADDRESS = exports.GENERATE_SALES_TAX_ENDPOINT = exports.LIST_TAXJAR_CUSTOMERS_ENDPOINT = exports.DELETE_TAXJAR_CUSTOMER_ENDPOINT = exports.VIEW_TAXJAR_CUSTOMER_ENDPOINT = void 0;
exports.DURATION_OPTIONS = exports.AUTO_RENEW = exports.PUBLISH_ACTIONS = exports.INITIAL_AUCTION_PRODUCT_STATE = exports.INITIAL_BUY_NOW_PRODUCT_STATE = exports.adminRoleConst = exports.testAccountObject = exports.VERIFICATION_LINK_SEND = exports.FINANCE_DOC_REJECTED = exports.FINANCE_DOC_ACCEPTED = exports.FINANCE_DOC_NOT_FOUND = exports.INVALID_REQUEST = exports.INVOICE_MARK_PAID_PASSED = exports.INVOICE_SELLER_WIRE_PASSED = exports.INVOICE_LINE_ITEMS_PASSED = void 0;
const enums_1 = require("./enums");
exports.PRODUCT_STATUS_FIELDS = {
    buyNowPrice: 'Buy it Now Price',
    finalSalePrice: 'Starting Price',
    reservePrice: 'Reserve Price',
    openingPrice: 'Starting Price',
    auctionDuration: 'Duration',
    publishAuction: 'Publish Auction',
    auctionScheduledTime: 'Scheduled Time',
    title: 'Title',
    model: 'Model',
    equipmentId: 'Equipment Type',
    productManufacturer: 'Equipment Manufacturer',
    year: 'Year',
    equipmentMileage: 'Equipment Mileage',
    equipmentHours: 'Equipment Hours',
    newOrUsedEquipment: 'New Or Used Equipment',
    serialNumber: 'Serial Number',
    equipmentVinNumber: 'Equipment VIN Number',
    description: 'Description',
    isTitledPieceOfEquipment: 'Is Titled Piece Of Equipment',
    doesThisEquipementRequireDismantling: 'Does This Equipement Require Dismantling',
    areYouWillingToHelpWithTheDismantlingProcess: 'Are You Willing To Help With The Dismantling Process',
    willDismantlingRequireCraneService: 'Will Dismantling Require Crane Service',
    willYouProvideTheElectricalDisconnectIfRequired: 'Will You Provide The Electrical Disconnect If Required',
    willYouLoadTheEquipmentOnToTheBuyersTrucks: 'Will You Load The Equipment On To The Buyers Trucks',
    toWhatExtentAreYouWillingToHelp: 'To What Extent Are You Willing To Help',
    isThereLienOnTheEquipment: 'Is There Lien On The Equipment',
    lienHolderName: 'Lien Holder Name',
    lienHolderEmail: 'Lien Holder Email',
    lienHolderPhone: 'Lien Holder Phone',
    contractDuration: 'Contract Duration',
    renewalWindow: 'Notification Duration',
    lienHolderPayoffAmount: 'Lien Holder Payoff Amount',
    isTheEquipmentAtADifferentAddress: 'Is The Equipment at a Different Address',
    equipmentCountry: 'Equipment Country',
    equipmentState: 'Equipment State',
    equipmentCity: 'Equipment City',
    equipmentZip: 'Equipment Zip Code',
    equipmentStreet: 'Equipment Street',
    attachments: 'PDF Attachments',
    images: 'Images',
    videos: 'Videos',
    firstChoice: 'Equipment Hours or Mileage',
    secondChoice: 'Serial Number or VIN',
    files: 'Images/Videos'
};
exports.ROLEMANAGEMENT_OBJECT = {
    firstName: '',
    lastName: '',
    mobileNumber: '',
    emailAddress: '',
    photoURL: '',
    role: ''
};
exports.CONTACT_OBJECT = {
    firstName: '',
    lastName: '',
    companyId: '',
    companyName: '',
    title: '',
    mobileNumber: '',
    emailAddress: '',
    photoURL: '',
    isPrimaryContact: false,
    newsletter: false,
    textMessage: false
};
exports.MONTH_NAMES = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
exports.BANK_ACCOUNT_INFO_INITIAL_STATE = {
    domesticWireInfo: {
        accountName: '',
        accountNumber: '',
        bank: '',
        routingNumber: ''
    },
    internationalWireInfo: {
        accountName: '',
        accountNumber: '',
        bank: '',
        routingNumber: '',
        swiftCode: ''
    }
};
// Stripe Endpoints
exports.CREATE_CUSTOMER_PAYMENT_ENDPOINT = '/payment/create-customer';
exports.ATTACH_PAY_METHOD_ENDPOINT = '/payment/attach-pay-method';
exports.DETACH_PAY_METHOD_ENDPOINT = '/payment/detach-pay-method';
exports.LIST_PAY_METHOD_ENDPOINT = '/payment/pay-method-list';
exports.CREATE_PAYMENT_INTENT_ENDPOINT = '/payment/create-payment-intent';
exports.UPDATE_PAYMENT_INTENT_ENDPOINT = '/payment/update-payment-intent';
exports.CAPTURE_PAYMENT_INTENT_ENDPOINT = '/payment/capture-payment-intent';
exports.CANCEL_PAYMENT_INTENT_ENDPOINT = '/payment/cancel-payment-intent';
exports.HANDLE_CAPTURE_PAYMENT_ENDPOINT = '/payment/handle-capture-payment';
// Invoice Endpoints
exports.INVOICE_GENERATION_ENDPOINT = '/invoice/generate';
exports.INVOICE_REGENERATION_ENDPOINT = '/invoice/regenerate';
exports.INVOICE_BUYER_WIRE_ADD_ENDPOINT = '/invoice/add-buyer-wire';
exports.INVOICE_ADMIN_BUYER_WIRE_ADD_ENDPOINT = '/invoice/admin-add-buyer-wire';
exports.INVOICE_SELLER_WIRE_ADD_ENDPOINT = '/invoice/add-seller-wire';
exports.INVOICE_MARK_PAID_ENDPOINT = '/invoice/mark-paid';
exports.INVOICE_LINE_ITEMS_ENDPOINT = '/invoice/line-items';
exports.INVOICE_MARK_CLOSED_ENDPOINT = '/invoice/mark-as-closed';
exports.INVOICE_MARK_RECEIVED_ENDPOINT = '/invoice/mark-as-received';
exports.INVOICE_MARK_BUYER_WIRE_AS_PAID_ENDPOINT = '/invoice/mark-buyer-wire-as-paid';
exports.INVOICE_REMOVE_ITEM_ENDPOINT = '/invoice/remove-invoice-item';
exports.INVOICE_RE_OPEN_ENDPOINT = '/invoice/re-open-invoice';
exports.INVOICE_ADD_COMMENT_ENDPOINT = '/invoice/add-comment';
// Account Endpoints
exports.CREATE_ACCOUNT_ENDPOINT = '/account/create';
exports.EDIT_ACCOUNT_ENDPOINT = '/account/update';
exports.DELETE_ACCOUNT_ENDPOINT = '/account/delete';
// Contact Endpoints
exports.CREATE_CONTACT_ENDPOINT = '/user/create';
exports.EDIT_CONTACT_ENDPOINT = '/user/update';
exports.DELETE_CONTACT_ENDPOINT = '/user/delete';
exports.FETCH_CONTACT_AUTH_ENDPOINT = '/user/auth-data';
// Finance Endpoints
exports.CREATE_FINANCE_DOCUMENT_ENDPOINT = '/finance/create';
exports.FINANCE_CONTACT_ACTION_ENDPOINT = '/user/finance/action';
// Send Verification Link
exports.VERIFY_EMAIL_ENDPOINT = 'user/verifyEmail';
exports.SEND_VERIFICATION_LINK_ENDPOINT = 'user/sendVerificationLink';
// Admin Endpoints
exports.CREATE_ADMIN_ENDPOINT = '/adminuser/create';
exports.EDIT_ADMIN_ENDPOINT = '/adminuser/update';
exports.DELETE_ADMIN_ENDPOINT = '/adminuser/delete';
exports.ADMIN_GRANT_ACCESS_ENDPOINT = '/adminuser/grant/access';
exports.ADMIN_DENY_ACCESS_ENDPOINT = '/adminuser/deny/access';
// Product Endpoints
exports.CREATE_PRODUCT_ENDPOINT = '/product/create';
exports.EDIT_PRODUCT_ENDPOINT = '/product/update';
exports.UPDATE_PRODUCT_PRICE_ENDPOINT = '/product/update-product-price';
exports.DELETE_PRODUCT_ENDPOINT = '/product/delete';
exports.DISABLE_BUYNOW_ENDPOINT = '/product/disable-buy-now';
// TaxJar Endpoints
exports.CREATE_TAXJAR_CUSTOMER_ENDPOINT = `/tax/create-customer`;
exports.UPDATE_TAXJAR_CUSTOMER_ENDPOINT = `/tax/update-customer`;
exports.VIEW_TAXJAR_CUSTOMER_ENDPOINT = `/tax/view-customer`;
exports.DELETE_TAXJAR_CUSTOMER_ENDPOINT = `/tax/delete-customer`;
exports.LIST_TAXJAR_CUSTOMERS_ENDPOINT = `/tax/get-customer-list`;
exports.GENERATE_SALES_TAX_ENDPOINT = `/tax/calculate-sale-tax`;
exports.VALIDATE_CUSTOMER_ADDRESS = `/tax/validate-customer-address`;
exports.UPLOAD_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = `/tax/upload-exemption-certificate`;
exports.UPDATE_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = `/tax/update-exemption-certificate`;
exports.REMOVE_TAX_EXEMPTION_CERTIFICATE_ENDPOINT = `/tax/remove-exemption-certificate`;
exports.UPDATE_EXEMPTION_TYPE_AND_REGIONS_ENDPOINT = `/tax/update-exemption-type-and-regions`;
// Helper EndPoints
exports.PREVEIW_LINK_HELPER_ENDPOINT = '/helper/preview-link';
exports.OG_PREVIEW_HELPER_ENDPOINT = '/helper/og-preview';
//DEAL ENDPOINT
exports.CREATE_DEAL_ENDPOINT = '/deal/create';
//ACH Transfer ENDPOINT
exports.ACH_TRANSFER_ENDPOINT = '/achTransfer/achTransferForSeller';
// Notification Endpoint
exports.CLIENT_SIDE_NOTIFICATIONS = '/notifications/clientSideNotification';
exports.REMINDER_NOTIFICATIONS = '/notifications/reminderNotification';
// Onboarding Endpoint
exports.ONBOARDING_CREATE = '/onboarding/create';
exports.ONBOARDING_UPDATE = '/onboarding/update';
// Zoho Sign Endpoint
exports.ZOHO_SIGN_LISTING_AGREEMENT = '/zohoSign/listingAgreement';
exports.ZOHO_SIGN_GENERAL_MSA_AGREEMENT = '/zohoSign/generalMsaAgreement';
exports.ZOHO_SIGN_GENERAL_RECALL_AGREEMENT = '/zohoSign/recallAgreement';
// Zoho Manual Sign Endpoint
exports.ZOHO_MANUAL_SIGN_GENERAL_MSA_AGREEMENT = '/zohoManualSign/manualMsaSigning';
exports.ZOHO_MANUAL_SIGN_LA_AGREEMENT = '/zohoManualSign/manualLaSigning';
// Validation Endpoint
exports.MOBILE_VALIDATION = '/validation/numVerify';
exports.CHECK_PRIMARY_CONTACT = '/validation/checkPrimaryContact';
// Products Migration
exports.FIREBASE_TO_ZOHO_PRODUCT_SYNC_ENDPOINT = '/productsMigration/fromFirebaseProductsToZohoProducts';
exports.ZOHO_TO_FIREBASE_PRODUCT_SYNC_ENDPOINT = '/productsMigration/startZohoProductSyncing';
// Account Migration
exports.FIREBASE_TO_ZOHO_ACCOUNT_SYNC_ENDPOINT = '/accountsMigration/fromFirebaseAccountsToZohoAccounts';
exports.ZOHO_TO_FIREBASE_ACCOUNT_SYNC_ENDPOINT = '/accountsMigration/startZohoAccountsSyncing';
exports.ZOHO_TO_FIREBASE_WEBSITE_ACCOUNT_SYNC_ENDPOINT = '/accountsMigration/zohoWebsiteAccountsAndContactsSync';
// Finance Endpoint
exports.CREATE_FINANCE_APPLICATION = '/finance/create';
// Endpoint Respone Messages
exports.ACCESS_GRANTED = 'Access Granted Successfully';
exports.ACCESS_DENIED = 'Access Denied Successfully';
exports.BAD_REQUEST = 'Bad Request';
exports.DATA_INSERTION_PASSED = 'Data Inserted Successfully';
exports.DATA_DELETION_PASSED = 'Data Deleted Successfully';
exports.DATA_UPDATION_PASSED = 'Data Updated Successfully';
exports.DATA_NOT_FOUND = 'Data Not Found';
exports.VALIDATION_ERROR = 'Validation Error';
exports.FORBIDDEN_ERROR = 'At least one primary contact is required.';
exports.SERVER_ERROR = 'Server Error';
exports.PAYMENT_METHOD_ATTACH = 'Payment Method Attach Succesfully';
exports.PAYMENT_METHOD_DETACH = 'Payment Method Detach Succesfully';
exports.PAYMENT_METHOD_LIST = 'Payment Method list';
exports.PAYMENT_INTENT_INSERTION_PASSED = 'Payment Intent Create Successfully';
exports.PAYMENT_INTENT_UPDATION_PASSED = 'Payment Intent Update Successfully';
exports.PAYMENT_INTENT_CAPTURE = 'Payment Intent Capture Successfully';
exports.PAYMENT_INTENT_CANCEL = 'Payment Intent Cancel Successfully';
exports.PAYMENT_WEBHOOK_PASSED = 'Payment Webhook Applied Successfully';
exports.INVOICE_GENERATION_PASSED = 'Invoice Generated Successfully';
exports.INVOICE_BUYER_WIRE_PASSED = 'Buyer Wire Added Successfully';
exports.INVOICE_LINE_ITEMS_PASSED = 'Line Items Added Successfully';
exports.INVOICE_SELLER_WIRE_PASSED = 'Seller Wire Added Successfully';
exports.INVOICE_MARK_PAID_PASSED = 'Invoice Paid Successfully';
exports.INVALID_REQUEST = 'Invalid Request Data. Please Review Request And Try Again';
exports.FINANCE_DOC_NOT_FOUND = 'Finance Document Not Found';
exports.FINANCE_DOC_ACCEPTED = 'Finance Document Accepted';
exports.FINANCE_DOC_REJECTED = 'Finance Document Reject';
exports.VERIFICATION_LINK_SEND = 'Verification Link Sent Successfully.';
exports.testAccountObject = {
    accountName: 'Tesla',
    accountId: '0ZU7eKQXX0XdnVwD4agU',
    accountInfo: {
        websiteURL: 'http://www.pop.pk',
        email: 'email@me.pk',
        phoneNumber: '+01231414121'
    },
    shippingAddress: {
        shippingStreetAddress: '799 Roosevelt Rd Bldg 4 Ste 305',
        shippingStreetAddress2: '2100 Jack Warner Pkwy NE',
        shippingCountry: 'USA',
        shippingState: 'Texas',
        shippingCity: 'Austin',
        shippingZipCode: 'ABC-123-P0'
    },
    billingAddress: {
        billingStreetAddress: 'Corporate Secretary, Tesla, Inc. 3500 Deer Creek Road',
        billingStreetAddress2: 'Palo Alto, CA 94304 United States',
        billingCountry: 'USA',
        billingState: 'Houstin',
        billingCity: 'New York',
        billingZipCode: 'TE-450'
    },
    hasSignedMSA: false,
    parentAccountId: '',
    isSynced: false,
    websiteAccount: true,
    sector: '',
    accountType: enums_1.AccountTypes.Other,
    descriptionInfo: 'Tesla, Inc. is an American multinational automotive and clean energy company headquartered in Austin, Texas. Tesla designs and manufactures electric vehicles, battery energy storage from home to grid-scale, solar panels and solar roof tiles, and related products and services.',
    createdAt: new Date().toISOString(),
    lastUpdated: new Date().toISOString()
};
exports.adminRoleConst = {
    superManager: 'Super Manager',
    superAdmin: 'Super Admin',
    MSA: 'MSA'
};
exports.INITIAL_BUY_NOW_PRODUCT_STATE = {
    productId: '',
    isFeaturedListing: false,
    isCommissionSetManually: false,
    isSynced: false,
    lastUpdated: new Date().toISOString(),
    listingType: enums_1.listingType.BuyNow,
    contractInfo: {
        durationInDays: 180,
        contractDuration: new Date(new Date().setDate(new Date().getDate() + 180)).toISOString(),
        renewalWindow: 30,
        autoRenew: true
    },
    title: '',
    model: '',
    equipmentId: '',
    year: new Date().getFullYear(),
    sellerPhotoUrl: '',
    productManufacturer: '',
    acceptOffers: true,
    newOrUsedEquipment: enums_1.newOrUsedEquipment.New,
    description: '',
    productDetails: {
        files: [],
        pdfAttachments: [],
        firstChoice: 'Equipment Hours or Mileage',
        secondChoice: 'Serial Number or VIN',
        attachments: [],
        images: [],
        videos: [],
        imageThumbnails: [],
        videoThumbnails: []
    },
    willYouProvideTheElectricalDisconnectIfRequired: false,
    willYouLoadTheEquipmentOnToTheBuyersTrucks: false,
    status: enums_1.productStatus.Pending,
    views: 0,
    createdAt: new Date().toISOString(),
    accountId: '',
    accountName: '',
    contactId: '',
    contactName: '',
    openingPriceMap: {
        openingPrice: 0,
        openingPriceTimestamp: new Date().toISOString()
    },
    finalSalePriceMap: {
        finalSalePrice: 0,
        finalSalePriceTimestamp: new Date().toISOString()
    },
    websiteLink: '',
    commissionPercentage: 10,
    expectedRevenue: 0,
    listingAgreementSigned: false,
    isTheEquipmentAtADifferentAddress: {
        isEquipmentAtADifferentAddress: false,
        equipmentCity: '',
        equipmentCountry: '',
        equipmentState: '',
        equipmentStreet: '',
        equipmentZip: ''
    },
    equipmentHours: null,
    equipmentMileage: null,
    equipmentVinNumber: null,
    serialNumber: null
};
exports.INITIAL_AUCTION_PRODUCT_STATE = Object.assign(Object.assign({}, exports.INITIAL_BUY_NOW_PRODUCT_STATE), { acceptOffers: false, listingType: enums_1.listingType.Auction, description: '', buyNowPriceMap: {
        buyNowPrice: 0,
        buyNowPriceTimestamp: new Date().toISOString()
    }, initialReservePriceMap: {
        reservePrice: 0,
        reservePriceTimestamp: new Date().toISOString()
    }, auctionInfo: {
        auctionDuration: '3',
        auctionScheduledTime: new Date().toISOString(),
        publishAuction: enums_1.publishAuction.NOW
    }, contractInfo: {
        autoRenew: true,
        durationInDays: 3,
        contractDuration: new Date(new Date().setDate(new Date().getDate() + 3)).toISOString()
    } });
exports.PUBLISH_ACTIONS = Object.values(enums_1.publishAuction).map((opt) => ({
    key: opt,
    value: opt
}));
exports.AUTO_RENEW = Object.values(enums_1.autoRenew).map((opt) => ({
    key: opt,
    value: opt
}));
exports.DURATION_OPTIONS = [
    { label: '3 days', value: '3' },
    { label: '5 days', value: '5' },
    { label: '7 days', value: '7' },
    { label: '9 days', value: '9' },
    { label: '10 days', value: '10' },
    { label: 'Other', value: 'Other' }
];
